import { shiftISODate, dateRangeLength } from "../../dates";
import {
  isFixedDateInterval,
  type FixedDateInterval,
  type DateInterval,
} from "../date-range";

import { enumType } from "./enum-type";

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 */
enum DateRangeChoice_ {
  monthToDate = "Month to date",
  yearToDate = "Year to date",
  today = "Today",
  yesterday = "Yesterday",
  yesterdayAndToday = "Yesterday and today",
  last3Days = "Last 3 days",
  lastMonth = "Last month",
  last7Days = "Last 7 days",
  last14Days = "Last 14 days",
  last28Days = "Last 28 days",
  last60Days = "Last 60 days",
}

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 */
export const DateRangeChoiceEnum = enumType({
  enumObject: DateRangeChoice_,
  keyOrder: [
    "today",
    "yesterday",
    "yesterdayAndToday",
    "last3Days",
    "last7Days",
    "last14Days",
    "last28Days",
    "last60Days",
    "lastMonth",
    "monthToDate",
    "yearToDate",
  ],
});

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * >>> DateRanges.getSubset("hourly")
 */
enum HourlyDateRangeChoice_ {
  today = "Today",
  todayAndYesterday = "Today and yesterday",
  yesterday = "Yesterday",
  last3Days = "Last 3 days",
  last7Days = "Last 7 days",
}

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * >>> DateRanges.getSubset("hourly")
 */
export const HourlyDateRangeChoiceEnum = enumType({
  enumObject: HourlyDateRangeChoice_,
  keyOrder: ["today", "yesterday", "last3Days", "last7Days"],
});

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * >>> DateRanges.getSubset("daily")
 */
enum DailyDateRangeChoice_ {
  today = "Today",
  todayAndYesterday = "Today and yesterday",
  yesterday = "Yesterday",
  last3Days = "Last 3 days",
  last7Days = "Last 7 days",
  last14Days = "Last 14 days",
  last30Days = "Last 30 days",
  last60Days = "Last 60 days",
  last6Months = "Last 6 months",
  last12Months = "Last 12 months",
  last18Months = "Last 18 months",
  lastYear = "Last year",
  monthToDate = "Month to date",
  lastMonth = "Last month",
  yearToDate = "Year to date",
}

enum DailyDateRangeMobileChoice_ {
  today = "Today",
  yesterday = "Yesterday",
  last3Days = "Last 3 days + Today",
  last7Days = "Last 7 days + Today",
  last14Days = "Last 14 days + Today",
  last30Days = "Last 30 days + Today",
  last60Days = "Last 60 days",
  last6Months = "Last 6 months",
  last12Months = "Last 12 months",
  last18Months = "Last 18 months",
  lastYear = "Last year",
  monthToDate = "Month to Today",
  lastMonth = "Last month",
  yearToDate = "Year to date",
}

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * >>> DateRanges.getSubset("daily")
 */
export const DailyDateRangeChoiceEnum = enumType({
  enumObject: DailyDateRangeChoice_,
  keyOrder: [
    "today",
    "yesterday",
    "last3Days",
    "last7Days",
    "last14Days",
    "last30Days",
    "last60Days",
    "last6Months",
    "lastYear",
    "lastMonth",
    "monthToDate",
    "yearToDate",
  ],
});

export const mobileWindowAdjustments = [
  "last3Days",
  "last7Days",
  "last14Days",
  "last30Days",
  "monthToDate",
  "yearToDate",
];

export const DailyDateRangeChoiceEnumMobile = enumType({
  enumObject: DailyDateRangeMobileChoice_,
  keyOrder: [
    "today",
    "yesterday",
    "last3Days",
    "last7Days",
    "last14Days",
    "last30Days",
    "last60Days",
    "last6Months",
    "lastYear",
    "lastMonth",
    "monthToDate",
    "yearToDate",
  ],
});

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * >>> DateRanges.getSubset("weekly")
 */
enum WeeklyDateRangeChoice_ {
  thisWeek = "This week",
  lastWeek = "Last week",
  thisWeekAndLastWeek = "This week and last week",
  last4Weeks = "Last month",
  last12Weeks = "Last 3 months",
  last26Weeks = "Last 6 months",
  last52Weeks = "Last year",
  yearToDate = "Year to date",
}

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * >>> DateRanges.getSubset("weekly")
 */
export const WeeklyDateRangeChoiceEnum = enumType({
  enumObject: WeeklyDateRangeChoice_,
  keyOrder: [
    "thisWeek",
    "lastWeek",
    "last4Weeks",
    "last12Weeks",
    "last26Weeks",
    "last52Weeks",
    "yearToDate",
  ],
});

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * >>> DateRanges.getSubset("monthly")
 */
enum MonthlyDateRangeChoice_ {
  yearToDate = "Year to date",
  last3Months = "Last 3 months",
  last6Months = "Last 6 months",
  lastYear = "Last year",
  last3Years = "Last 3 years",
  last5Years = "Last 5 years",
}

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * >>> DateRanges.getSubset("monthly")
 */
export const MonthlyDateRangeChoiceEnum = enumType({
  enumObject: MonthlyDateRangeChoice_,
  keyOrder: [
    "yearToDate",
    "last3Months",
    "last6Months",
    "lastYear",
    "last3Years",
    "last5Years",
  ],
});

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 */
export const AllDateRangeChoiceEnum = enumType({
  enumObject: {
    ...HourlyDateRangeChoice_,
    ...DailyDateRangeChoice_,
    ...WeeklyDateRangeChoice_,
    ...MonthlyDateRangeChoice_,
  },
  keyOrder: [
    "today",
    "todayAndYesterday",
    "yesterday",
    "last3Days",
    "last7Days",
    "last14Days",
    "last30Days",
    "last60Days",
    "monthToDate",
    "lastMonth",
    "thisWeek",
    "thisWeekAndLastWeek",
    "lastWeek",
    "last4Weeks",
    "last12Weeks",
    "last26Weeks",
    "last52Weeks",
    "yearToDate",
    "last6Months",
    "lastYear",
    "last3Years",
    "last5Years",
  ],
});

export const AllMobileDateRangeChoiceEnum = enumType({
  enumObject: {
    ...HourlyDateRangeChoice_,
    ...DailyDateRangeChoice_,
    ...WeeklyDateRangeChoice_,
    ...MonthlyDateRangeChoice_,
    ...DailyDateRangeMobileChoice_,
  },
  keyOrder: [
    "today",
    "todayAndYesterday",
    "yesterday",
    "last3Days",
    "last7Days",
    "last14Days",
    "last30Days",
    "last60Days",
    "monthToDate",
    "lastMonth",
    "thisWeek",
    "thisWeekAndLastWeek",
    "lastWeek",
    "last4Weeks",
    "last12Weeks",
    "last26Weeks",
    "last52Weeks",
    "yearToDate",
    "last3Months",
    "last6Months",
    "last12Months",
    "last18Months",
    "lastYear",
    "last3Years",
    "last5Years",
  ],
});

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * Additionally, newer v2 select components do not use react-select, and the label/value properties
 * can be directly accessible from the enumerated instance.
 */
export const DailyReactSelectChoices =
  DateRangeChoiceEnum.reactSelectOptions.filter(
    (v) =>
      !!(
        {
          today: true,
          yesterday: true,
          last3Days: true,
          last7Days: true,
          last14Days: true,
          last28Days: true,
          last60Days: true,
          monthToDate: true,
          lastMonth: true,
        } as any
      )[v.value],
  );

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 * Additionally, newer v2 select components do not use react-select, and the label/value properties
 * can be directly accessible from the enumerated instance.
 */
export const HourlyReactSelectChoices =
  DateRangeChoiceEnum.reactSelectOptions.filter(
    (v) =>
      !!(
        {
          today: true,
          yesterday: true,
          yesterdayAndToday: true,
          last3Days: true,
        } as any
      )[v.value],
  );

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 */
export type DateRangeChoiceV2 = keyof typeof DateRangeChoice_;

/**
 * @deprecated
 * Please see @nb-common/constants//date-range.ts
 */
export type DateRangeChoiceV3 =
  | keyof typeof HourlyDateRangeChoice_
  | keyof typeof DailyDateRangeChoice_
  | keyof typeof WeeklyDateRangeChoice_
  | keyof typeof MonthlyDateRangeChoice_;

export type DateRangeChoiceV4 =
  | "yesterday"
  | "today"
  | "last3Days"
  | "last7Days"
  | "last14Days"
  | "last30Days"
  | "last60Days"
  | "last6Months"
  | "last12Months"
  | "lastMonth"
  | "monthToDate"
  | "yearToDate";

/**
 * @deprecated
 * Please see @nb-common/constants//compare-date-range.ts
 */
enum CompareDateRange_ {
  lastPeriod = "Last period",
  last3Days = "Last 3 days",
  last7Days = "Last 7 days",
  last14Days = "Last 14 Days",
  last28Days = "Last 28 Days",
  last60Days = "Last 60 Days",
}

/**
 * @deprecated
 * Please see @nb-common/constants//compare-date-range.ts
 */
export const CompareDateRangeEnum = enumType({
  enumObject: CompareDateRange_,
  keyOrder: [
    "lastPeriod",
    "last3Days",
    "last7Days",
    "last14Days",
    "last28Days",
    "last60Days",
  ],
});

/**
 * @deprecated
 * Please see @nb-common/constants//compare-date-range.ts
 */
export const HourlyCompareReactSelectChoices =
  CompareDateRangeEnum.reactSelectOptions.filter(
    (v) => v.value === "lastPeriod",
  );

/**
 * @deprecated
 * Please see @nb-common/constants//compare-date-range.ts
 */
export type ICompareDateRangeEnum = keyof typeof CompareDateRange_;

/* TODO: Move me to @nb-common/constants//compare-date-range alongside the definition of the
   CompareDateRange type. */
export function resolveCompareDateRange(
  dateRange: DateInterval,
  compareDateInterval: ICompareDateRangeEnum | FixedDateInterval,
): DateInterval {
  if (isFixedDateInterval(compareDateInterval)) {
    const { startDate, endDate } = compareDateInterval;
    return { startDate, endDate };
  }

  let daysToShift = 60;
  if (compareDateInterval === "lastPeriod") {
    daysToShift = dateRangeLength(dateRange);
  } else if (compareDateInterval === "last3Days") {
    daysToShift = 3;
  } else if (compareDateInterval === "last7Days") {
    daysToShift = 7;
  } else if (compareDateInterval === "last14Days") {
    daysToShift = 14;
  } else if (compareDateInterval === "last28Days") {
    daysToShift = 28;
  } else if (compareDateInterval === "last60Days") {
    daysToShift = 60;
  }

  const startDate = shiftISODate(dateRange.startDate, -daysToShift);
  const endDate = shiftISODate(dateRange.endDate, -daysToShift);

  return { startDate, endDate };
}

/**
 * @deprecated
 * Please refer to @nb-common/constants//attribution-window.ts
 */
const MCAttributionWindowDaysEnum = {
  "1": "1 day",
  "3": "3 day",
  "7": "7 day",
  "14": "14 day",
  "30": "30 day",
  "60": "60 day",
  "90": "90 day",
  infinity: "Infinite",
} as const;

/**
 * @deprecated
 * Please refer to @nb-common/constants//attribution-window.ts
 */
export const MCAttributionWindowDays = enumType({
  enumObject: MCAttributionWindowDaysEnum,
  keyOrder: ["infinity", "90", "60", "30", "14", "7", "3", "1"],
});

export type IMCAttributionWindowDays = keyof typeof MCAttributionWindowDaysEnum;

/**
 * @deprecated
 * Please refer to @nb-common/constants//attribution-window.ts
 */
export const MCAttributionWindowDaysChoicesDaily =
  MCAttributionWindowDays.reactSelectOptions
    .slice()
    .filter(
      (
        v,
      ): v is {
        value: Exclude<
          (typeof MCAttributionWindowDays.reactSelectOptions)[number]["value"],
          "infinity"
        >;
        label: string;
      } => v.value !== "infinity",
    )
    .reverse();

/**
 * @deprecated
 * Please refer to @nb-common/constants//attribution-window.ts
 */
export const MCAttributionWindowDaysChoicesHourly =
  MCAttributionWindowDays.reactSelectOptions
    .slice()
    .filter(
      (
        v,
      ): v is {
        label: string;
        value: Extract<
          (typeof MCAttributionWindowDays.reactSelectOptions)[number]["value"],
          "1"
        >;
      } => v.value === "1",
    )
    .reverse();

export enum ColumnSetEnum {
  overview = "Overview",
  traffic = "Traffic",
  first_time_vs_returning = "First-time vs Returning",
}

export const ColumnSet = enumType({
  enumObject: ColumnSetEnum,
  keyOrder: ["overview", "traffic", "first_time_vs_returning"],
});

export type IColumnSet = keyof typeof ColumnSet.enum;

export const Granularity = enumType({
  enumObject: {
    platform: "Platform",
    campaign: "Campaign",
    adset: "Adset",
    ad: "Ad",
  } as const,
  keyOrder: ["platform", "campaign", "adset", "ad"],
});

export type IGranularity = keyof typeof Granularity.enum;

/**
 * @deprecated
 * Please refer to @nb-common/constants//time-granularity.ts
 */
export const TimeGranularity_Deprecated = enumType({
  enumObject: {
    daily: "Daily",
    hourly: "Hourly",
  } as const,
  keyOrder: ["daily", "hourly"],
});

export type ITimeGranularity = keyof typeof TimeGranularity_Deprecated.enum;

export const TimeGranularityV2 = enumType({
  enumObject: {
    monthly: "Monthly",
    weekly: "Weekly",
    daily: "Daily",
    hourly: "Hourly",
  } as const,
  keyOrder: ["monthly", "weekly", "daily", "hourly"],
});

export type ITimeGranularityV2 = keyof typeof TimeGranularityV2.enum;

export const NBAccountingMode = enumType({
  enumObject: {
    cash: "Cash snapshot",
    accrual: "Accrual performance",
  } as const,
  keyOrder: ["accrual", "cash"],
});

export type INBAccountingMode = keyof typeof NBAccountingMode.enum;

export function dateRangeOptionsForTimeGranularity(
  timeGranularity: ITimeGranularityV2,
) {
  switch (timeGranularity) {
    case "hourly":
      return HourlyDateRangeChoiceEnum.reactSelectOptions;
    case "daily":
      return DailyDateRangeChoiceEnum.reactSelectOptions;
    case "weekly":
      return WeeklyDateRangeChoiceEnum.reactSelectOptions;
    case "monthly":
      return MonthlyDateRangeChoiceEnum.reactSelectOptions;
    default:
      return DailyDateRangeChoiceEnum.reactSelectOptions;
  }
}

export function dateRangeOptionsForTimeGranularityMobile(
  timeGranularity: ITimeGranularityV2,
) {
  switch (timeGranularity) {
    case "daily":
      return DailyDateRangeChoiceEnumMobile.reactSelectOptions;
    case "weekly":
      return WeeklyDateRangeChoiceEnum.reactSelectOptions;
    case "monthly":
      return MonthlyDateRangeChoiceEnum.reactSelectOptions;
    default:
      return DailyDateRangeChoiceEnum.reactSelectOptions;
  }
}

// TODO: Move definitions to @nb-common/constants//time-granularity.ts
export const DEFAULT_DATE_RANGE_CHOICE_FOR_TIME_GRANULARITY = {
  hourly: "last7Days",
  daily: "last7Days",
  weekly: "last4Weeks",
  monthly: "last6Months",
} as const;
